// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"294":"830d8df2b4b685a0","501":"8912c939db880852","822":"0c8f523d5b5e0198","2121":"579bd4c2b251c9d6"}[chunkId] + ".js";
};